import React from "react";
import { Button, CircularProgress } from "@mui/material";
import PropTypes from "prop-types";

const ButtonComponent = ({ field, onClick, isSubmitting }) => {
  if (!field.show) return null;

  const { fieldId, fieldName, btnAction, disabled } = field;

  const handleButtonClick = () => {
    if (btnAction === "submit") return;
    if (btnAction === "reset") return;
    if (btnAction === "button") return onClick(fieldId, "cancel");

    onClick(fieldId, btnAction);
  };

  return (
    <Button
      type={btnAction}
      variant={btnAction === "submit" ? "contained" : "outlined"}
      color={btnAction === "submit" ? "primary" : "inherit"}
      size="medium"
      onClick={handleButtonClick}
      disabled={isSubmitting || disabled}
      sx={{ margin: 1 }}
    >
      {isSubmitting && btnAction === "submit" ? (
        <CircularProgress size={24} color="inherit" />
      ) : (
        fieldName
      )}
    </Button>
  );
};

ButtonComponent.propTypes = {
  field: PropTypes.shape({
    fieldId: PropTypes.string.isRequired,
    fieldName: PropTypes.string.isRequired,
    btnAction: PropTypes.oneOf(["submit", "reset", "button"]).isRequired,
    disabled: PropTypes.bool,
    show: PropTypes.bool,
  }).isRequired,
  onClick: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
};

export default ButtonComponent;
